import type { Theme } from '@mui/material/styles';

export const STRONG_FROM = 8;

export const ATTENTION_BELOW = 5;

export const MAX_SCORE = 10;

export type ScoreBand = 'high' | 'medium' | 'low';

export function scoreBand(score: number): ScoreBand {
  if (score >= STRONG_FROM) return 'high';
  return score >= ATTENTION_BELOW ? 'medium' : 'low';
}

export function scoreText(theme: Theme, score: number): string {
  return theme.palette.score[scoreBand(score)].text;
}

export function scoreTint(theme: Theme, score: number): string {
  return theme.palette.score[scoreBand(score)].bg;
}

export function formatScore(score: number): string {
  return score.toFixed(1);
}

export function needsAttention(score: number): boolean {
  return score < ATTENTION_BELOW;
}

export function formatRanAt(iso: string): string {
  const date = new Date(iso);
  const day = new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(date);
  const time = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' }).format(
    date,
  );
  return `${day}, ${time}`;
}

export function formatDayMonth(iso: string): string {
  return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short' }).format(new Date(iso));
}
